import React, {useEffect, useState} from 'react';
import "./onboard-hint-style.scss";
import IconTooltip from './images/tooltip.svg';
import IconTooltipBuy from './images/tooltip-s.svg';

const OnboardHint = (props) => {

    const {title, content, sideLeft, buyPackage} = props;

    const [visible, setVisible] = useState(false);

    const generationId = Math.floor(Math.random() * 1000);

    const backgroundClick = () => {
        setVisible(false);
    }

    const handleOnHintClick = () => {
        document.querySelectorAll('.onboard-hint-over-root').forEach(ele => {
            ele.style.display = 'none'
        });
        setVisible(!visible)
    }

    useEffect(() => {
        document.getElementById("onboard-hint-icon-" + generationId).addEventListener("mousemove", function () {
            setVisible(true);
        });
    }, []);

    useEffect(() => {
        if (visible)
            document.getElementById("onboard-hint-opacity-" + generationId).addEventListener("mousemove", function () {
                setVisible(false);
            });
    }, [visible]);


    return (
        <span className="onboard-hint-over-full">
            <div id={"onboard-hint-icon-" + generationId} className="onboard-hint-icon">
                <img onClick={() => handleOnHintClick()} alt="hint"
                     src={buyPackage ? IconTooltipBuy : IconTooltip}/>
            </div>
            {
                visible && (
                    <>
                        <div className="onboard-hint-opacity" id={"onboard-hint-opacity-" + generationId}
                             onClick={() => backgroundClick()}></div>
                        <div className={"onboard-hint-over-root " + (sideLeft ? 'left' : '')}>
                            <p className="onboard-hint-over-title">{title}</p>
                            <p className="onboard-hint-over-content">{content}</p>
                        </div>
                    </>
                )
            }
        </span>
    )
};

export default OnboardHint;
